import Image from 'next/image';

import { Box, Flex, Heading } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';
import { AccreditationAboutProps, AccreditationColorScheme } from '~/features/accreditation/types';

export function AccreditationAboutSection({
  colorScheme = 'blue',
  description,
  certificateImage,
}: { colorScheme?: AccreditationColorScheme } & AccreditationAboutProps) {
  return (
    <ContentContainer as='section' contentMaxWidth='content-max-width-md' isolation='isolate' mobilePadding='0'>
      <Flex
        alignItems={{ base: 'center', xl: 'flex-start' }}
        flexDirection={{ base: 'column', xl: 'row' }}
        position='relative'
      >
        <Flex
          bg={`${colorScheme}.50`}
          border='solid 1px'
          borderColor={`${colorScheme}.100`}
          borderLeftColor={{ base: 'transparent', md: `${colorScheme}.100` }}
          borderRadius={{ base: 0, md: '8px' }}
          borderRightColor={{ base: 'transparent', md: `${colorScheme}.100` }}
          flexDirection='column'
          gap={{ base: '32px', xl: '64px' }}
          height='fit-content'
          isolation='isolate'
          overflow='hidden'
          p={{ base: '32px 32px 72px 32px', xl: '48px' }}
          position='relative'
          w={{ base: '100%', xl: '460px' }}
        >
          <Box display={{ base: 'none', xl: 'block' }} mixBlendMode='multiply' position='absolute' right={0} top={0}>
            <Image
              alt=''
              height={417}
              src='/images/accreditation/about-bg.png'
              width={233}
              style={{
                filter: 'grayscale(100%)',
              }}
            />
          </Box>
          <Box display={{ base: 'block', xl: 'none' }} mixBlendMode='multiply' position='absolute' right={0} top={0}>
            <Image
              alt=''
              height={272}
              src='/images/accreditation/about-bg.png'
              width={152}
              style={{
                filter: 'grayscale(100%)',
              }}
            />
          </Box>
          <Flex flexDirection='column' gap={{ base: '24px', xl: '32px' }}>
            <Heading as='h2' size={{ base: 'mobile-heading-3', xl: 'heading-3' }}>
              Udacity Institute of AI and Technology
            </Heading>
            <Box bg={`${colorScheme}.100`} h='1px' w='100%' />
            {description}
          </Flex>
          <Flex alignItems='center' display={{ base: 'none', xl: 'flex' }} gap='40px'>
            <Image
              alt='Udacity Accenture logo'
              height={32}
              src='/images/logos/udacity-accenture-blue.svg'
              width={135}
            />
            <Image alt='Woolf logo' height={22} src='/images/logos/woolf-logo-blue.svg' width={120} />
          </Flex>
          <Flex alignItems='center' display={{ base: 'flex', xl: 'none' }} gap='32px'>
            <Image
              alt='Udacity Accenture logo'
              height={24}
              src='/images/logos/udacity-accenture-blue.svg'
              width={102}
            />
            <Image alt='Woolf logo' height={16.5} src='/images/logos/woolf-logo-blue.svg' width={90} />
          </Flex>
        </Flex>
        <Box
          height={{ base: '380px', sm: '560px', md: '500px' }}
          mt={{ base: '-80px', xl: '0' }}
          position={{ base: 'unset', xl: 'absolute' }}
          right={{ base: 'unset', xl: '-80px' }}
          top={{ base: 'unset', xl: '-20px' }}
          width={{ base: '500px', sm: '700px' }}
          zIndex={1}
        >
          <Image
            alt=''
            height={1128}
            loading='lazy'
            quality={100}
            src={certificateImage}
            style={{ pointerEvents: 'none' }}
            width={701}
          />
        </Box>
      </Flex>
    </ContentContainer>
  );
}
